"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/index");

var _Systems = _interopRequireDefault(require("../systems/Systems"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var Invests =
/** @class */
function (_super) {
  __extends(Invests, _super);

  function Invests() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(Invests.prototype, "id", {
    get: function () {
      return this.opts.id || 'tropical-invests';
    },
    enumerable: false,
    configurable: true
  });

  Invests.prototype.source = function () {
    var request = this.account.api().endpoint('tropicalcyclones').action("search"
    /* SEARCH */
    ).limit(50).filter('invests');
    var properties = {
      id: 'id',
      category: 'details.stormCat',
      timestamp: 'timestamp',
      points: ['track', 'forecast']
    };
    return {
      type: 'vector',
      data: {
        service: request,
        properties: properties,
        formatter: function (data) {
          return (0, _utils.formatStormData)(data);
        }
      },
      style: {
        marker: function (data) {
          return (0, _utils.getStormMarkerConfig)(data);
        },
        polygon: function (data) {
          return {
            fill: {
              color: '#ffffff',
              opacity: 0.7
            }
          };
        },
        polyline: function (data) {
          var type = (0, _index.get)(data, 'details.stormCat');
          return {
            stroke: {
              color: (0, _utils.color)(type),
              width: 3
            }
          };
        }
      },
      animation: {
        enabled: true
      }
    };
  };

  Invests.prototype.controls = function () {
    return {
      value: this.id,
      title: 'Invests'
    };
  };

  return Invests;
}(_Systems.default);

var _default = Invests;
exports.default = _default;
module.exports = exports.default;